import React, { useState, useEffect } from "react";
import "./VideoList.css";
import StampPop from "./StampPop";

const VideoList = ({ timestampData, thumbnail, title }) => {
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  // Load all videos from localStorage on mount
  useEffect(() => {
    loadVideosFromStorage();
  }, []); // Run only on mount

  // Update when props change (new video added)
  useEffect(() => {
    if (timestampData && thumbnail && title) {
      loadVideosFromStorage();
    }
  }, [timestampData, thumbnail, title]);

  const loadVideosFromStorage = () => {
    try {
      const historyKey = "timestamp_history";
      const historyData = localStorage.getItem(historyKey);
      
      if (historyData) {
        const parsed = JSON.parse(historyData);
        console.log("VideoList: Loading history from localStorage:", parsed);
        setVideos(Array.isArray(parsed) ? parsed : []);
      } else {
        // Fallback to latest entry if no history exists
        const latestData = localStorage.getItem("timestamp_latest");
        if (latestData) {
          const parsed = JSON.parse(latestData);
          console.log("VideoList: Loading latest from localStorage:", parsed);
          setVideos([parsed]);
        }
      }
    } catch (error) {
      console.error("VideoList: Error loading from localStorage:", error);
      setVideos([]);
    }
  };

  const handleRefresh = () => {
    loadVideosFromStorage();
  };

  const handleViewTimestamps = (video) => {
    setSelectedVideo(video);
    setShowPopup(true);
  };

  if (videos.length === 0) {
    return null;
  }

  return (
    <>
      <div className="video-list">
        <div className="video-list-header">
          <h2 className="video-list-header-title">Timestamp Generation History</h2>
          <button 
            className="video-list-refresh-button"
            onClick={handleRefresh}
            title="Refresh from localStorage"
          >
            ↻
          </button>
        </div>
        
        <div className="video-list-items">
          {videos.map((video, index) => (
            <div key={video.videoId || index} className="video-list-item">
              {video.videoData?.thumbnailUrl && (
                <img 
                  src={video.videoData.thumbnailUrl} 
                  alt={video.videoData.title || "Video thumbnail"} 
                  className="video-list-thumbnail"
                />
              )}
              
              <div className="video-list-content">
                {video.videoData?.title && (
                  <h3 className="video-list-title">{video.videoData.title}</h3>
                )}
                
                <button 
                  className="video-list-button"
                  onClick={() => handleViewTimestamps(video)}
                >
                  View Timestamps
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Timestamp popup */}
      {showPopup && selectedVideo && selectedVideo.data && (
        <StampPop
          data={selectedVideo.data}
          onClose={() => {
            setShowPopup(false);
            setSelectedVideo(null);
          }}
        />
      )}
    </>
  );
};

export default VideoList;
